import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmModalComponent } from 'src/app/shared/confirm-modal/confirm-modal.component';
import { VssEvent } from 'src/app/shared/models/vss-event.module';
import { ToastService } from 'src/app/shared/toast/toast.service';
import { EventsService } from './events.service';

@Component({
    selector: 'app-events',
    templateUrl: './events.component.html',
    styleUrls: ['./events.component.css'],
    standalone: false
})
export class EventsComponent implements OnInit {

  @ViewChild('confirmModal') confirmModal: ConfirmModalComponent;

  public currentOrganizationId: number;
  public currentLang;
  public events: VssEvent[] = [];
  public icons: { [name: string]: any } = {
    'faEdit': faEdit,
    'faTrashAlt': faTrashAlt
  };

  constructor(private _activatedRoute: ActivatedRoute, private _router: Router, private _eventsService: EventsService,
    private _translate: TranslateService, private _toastService: ToastService) { }

  ngOnInit(): void {
    this.currentLang = this._translate.currentLang.toLowerCase();
    const urlPramas = this._activatedRoute.snapshot.params;
    if (!urlPramas.orgId) {
      this._router.navigate(['']);
    }
    this.currentOrganizationId = urlPramas.orgId;
    this._eventsService.getOrganizationEvents(this.currentOrganizationId.toString()).subscribe((result: VssEvent[]) => {
      console.log(result);
      this.events = result;
    });
    this._toastService.remove();
  }

  public onEventDelete(eventId: number, index: number) {
    this.confirmModal.open(this._translate.instant('ORGANIZATION.EVENTS.deleteEvent'), this._translate.instant('ORGANIZATION.EVENTS.deleteEventQuestion'));
    this.confirmModal.confirmationResult.subscribe(result => {
      if (result) {
        this._eventsService.deleteEvent(eventId).subscribe(deleteResult => {
          this.events.splice(index, 1);
        });
      }
    });
  }

}
